import { render, staticRenderFns } from "./create.vue?vue&type=template&id=7d68ce9f&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d68ce9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d68ce9f')) {
      api.createRecord('7d68ce9f', component.options)
    } else {
      api.reload('7d68ce9f', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=7d68ce9f&scoped=true&", function () {
      api.rerender('7d68ce9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/plombs/create.vue"
export default component.exports